'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _Modal = require('@material-ui/core/Modal');
var _Modal2 = _interopRequireDefault(_Modal);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var styles = {
  paper: {
    backgroundColor: '#FAFAFD',
    position: 'absolute',
    width: '75%',
    maxWidth: function maxWidth(_ref) {
      var fixedWidth = _ref.fixedWidth;
      return !!fixedWidth ? 573 : '85%';
    },
    boxShadow: '0 3px 10px rgba(0, 0, 0, 0.16)',
    padding: '1rem',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    overflow: 'auto',
    maxHeight: '85%',
    borderRadius: 10,
    outline: 'none'
  }
};
var CustomModal = function (_Component) {
  _inherits(CustomModal, _Component);
  function CustomModal(props) {
    _classCallCheck(this, CustomModal);
    return _possibleConstructorReturn(this, (CustomModal.__proto__ || Object.getPrototypeOf(CustomModal)).call(this, props));
  }
  _createClass(CustomModal, [{
    key: 'render',
    value: function render() {
      var classes = this.props.classes;
      return _react2.default.createElement(_Modal2.default, {
        'aria-labelledby': 'simple-modal-title',
        'aria-describedby': 'simple-modal-description',
        open: true,
        onClose: this.props.onClose,
        BackdropProps: {
          style: {
            backgroundColor: '#3B2F3C',
            opacity: '0.6'
          }
        }
      }, _react2.default.createElement('div', {
        className: classes.paper
      }, this.props.children));
    }
  }]);
  return CustomModal;
}(_react.Component);
exports.default = (0, _reactJss2.default)(styles)(CustomModal);